<template>
  <div class="awards-swiper">
    <swiper :options="swiperOptions" ref="swiper" v-if="awardList">
      <swiper-slide v-for="(item, index) in awardList" :key="index">
        <div class="award-card">
          <img :src="item.awardLogo" class="logo" />
          <div>
            <span class="title">{{ item.awardTitle }}</span><br/>
            <span class="title" v-if="item.awardSubtitle">{{ item.awardSubtitle }}</span>
            <p class="field" v-if="item.awardField">{{ item.awardField }}</p>
          </div>
        </div>
      </swiper-slide>

      <div class="swiper-pagination"  slot="pagination"></div>
    </swiper>
  </div>
    <!-- <div class="recognised">
        <div class="title">
            Recognised By
        </div>
        <div class="main-badge">
            <img src="./../../assets/imgs/pc/Recognised/TUDAWinnerBadges2022.png" class="prop-badge"/>
            <img src="./../../assets/imgs/pc/Recognised/startUp2022.png" class="com-badge"/>
            <img src="./../../assets/imgs/pc/Recognised/proptech2022.png" class="com-badge"/>
            <img src="./../../assets/imgs/pc/Recognised/design2022.png" class="com-badge"/>
            <img src="./../../assets/imgs/pc/Recognised/acs.png" class="acs-badge"/>
            <img src="./../../assets/imgs/pc/Recognised/stone.png" class="stone-badge"/>
        </div>
    </div> -->
</template>
<script>

export default ({
  data() {
    return {
      awardList: [
        {
          awardTitle: "Member of",
          awardSubtitle: null,
          awardField: "ACS",
          awardLogo: require('@/assets/imgs/pc/Recognised/acsColor.png')
        },
        {
          awardTitle: "Member of",
          awardSubtitle: null,
          awardField: "Stone & Chalk",
          awardLogo: require('@/assets/imgs/pc/Recognised/stoneAndChalkColor.png')
        },
        {
          awardTitle: "The Urban Developer ",
          awardSubtitle: "Awards Finalist",
          awardField: "Best New PropTech",
          awardLogo: require('@/assets/imgs/pc/Recognised/urbanDeveloper.png')
        },
        {
          awardTitle: "Proptech Awards",
          awardSubtitle: "Finalist",
          awardField: "Design & Development",
          awardLogo: require('@/assets/imgs/pc/Recognised/propTechDesign.png')
        },
        {
          awardTitle: "Proptech Awards",
          awardSubtitle: "Finalist",
          awardField: "Operations & Management",
          awardLogo: require('@/assets/imgs/pc/Recognised/propTechOperation.png')
        },
        {
          awardTitle: "Proptech Awards",
          awardSubtitle: "Finalist",
          awardField: "Efficiency & Optimisation",
          awardLogo: require('@/assets/imgs/pc/Recognised/propTechEfficiency.png')
        },
        {
          awardTitle: "Proptech Awards ",
          awardSubtitle: "Finalist",
          awardField: "Design, Build & Develop",
          awardLogo: require('@/assets/imgs/pc/Recognised/propTechDevelop.png')
        },
        {
          awardTitle: "Proptech Awards",
          awardSubtitle: "Finalist",
          awardField: "Proptech for Good",
          awardLogo: require('@/assets/imgs/pc/Recognised/propTechGood.png')
        },
      ],
      swiperOptions: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          // 1200: { slidesPerView: 5, slidesPerGroup: 5 },
          992: { slidesPerView: 3, slidesPerGroup: 3 },
          768: { slidesPerView: 2, slidesPerGroup: 2 },
          480: { slidesPerView: 1, slidesPerGroup: 1 }
        },
        on: {
          init() {
            this.el.querySelectorAll('.swiper-slide-duplicate').forEach(el => el.setAttribute('aria-hidden', 'true'));
          },
          loopFix() {
            this.el.querySelectorAll('.swiper-slide-duplicate').forEach(el => el.setAttribute('aria-hidden', 'true'));
          }
        }
      }
    }
  },
  mounted() {}
});
</script>


<style scoped>
.awards-swiper {
  width: 100%;     
}
.award-card {
  display: flex;
  flex-direction: column;
  gap: 40px;
  text-align: center;
  align-items: center;
  margin-bottom: 60px !important; 
  .logo {
    height: 55px;
    object-fit: contain;
  }
  .title {
    color: #062440;
    text-align: center;
    font-family: Poppins-Bold;
    font-size: 16px;
    line-height: 22px;
    width: 100%;
  }
  .field {
    color: #062440;
    padding-top: 8px;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
  }
}
.swiper-pagination {
  margin-top: 30px;
}
</style>
<!-- <style lang="scss" scoped>

.recognised{
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // height: 82.32px;
}
.title{
  margin:0 0 20px 0;
  width: 84px;
  height: 18px;
  flex-grow: 0;
  font-family: Poppins;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 18px;
  letter-spacing: normal;
  text-align: left;
  // text-align: left;
  color: #A9AEB8;
  white-space: nowrap;
}
.main-badge{
  display: flex;
  flex-direction: row;

}
.com-badge{
  margin:0 9px;
  width: 27.04px;
  height: 30px;
}
.prop-badge{
  margin:0 9px;
  width: 30px;
  height: 30px;
}
.acs-badge{
  margin:0 9px;
  width: 56px;
  height: 30px;
}
.stone-badge{
  margin:0 9px;
  width: 80px;
  height: 30px;
}
</style> -->
